import { Close } from '@mui/icons-material';
import { Alert, AlertTitle, IconButton, Portal, Snackbar } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import { AlertType } from '../common/enums/enums';

const GenSnackBar = ({
  open,
  title,
  message,
  type,
  actions,
  onClose,
  autoHideDuration = 6000,
  color,
  icon,
}) => {
  return (
    <Portal>
      <Snackbar
        open={open}
        autoHideDuration={autoHideDuration}
        onClose={onClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          variant="filled"
          severity={type}
          action={
            <>
              {actions}
              <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={onClose}
              >
                <Close fontSize="small" />
              </IconButton>
            </>
          }
          icon={icon}
          sx={{
            backgroundColor: color,
          }}
        >
          {(message && <AlertTitle>{title}</AlertTitle>) || title}
          {message}
        </Alert>
      </Snackbar>
    </Portal>
  );
};

GenSnackBar.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  title: PropTypes.string,
  message: PropTypes.string,
  actions: PropTypes.node,
  type: PropTypes.oneOf(Object.values(AlertType)),
};

export default GenSnackBar;
